export default __webpack_public_path__ + "e63982a74e19ad5cbbbf9db64f56e1fc.png";